<!--
 * @Descripttion: 
 * @version: 
 * @Author: tangyuan
 * @Date: 2020-11-23 14:31:04
 * @LastEditors: tangyuan
 * @LastEditTime: 2021-01-29 16:40:58
-->
<template>
    <div class="footer">
        <diuv class="main-box">
            <div class="f-left">
                <div class="f-nav">
                    <router-link to="/home">网站首页</router-link>
                    <router-link to="/introduction">公司介绍</router-link>
                    <router-link to="/business_index/business">主营业务</router-link>
                    <router-link to="/cooperation_brand">合作品牌</router-link>
                    <!-- <router-link to="/cooperation_business">商务合作</router-link> -->
                </div>
                <div class="f-info">
                    <dl class="item" v-for="(item, index) in info" :key="index">
                        <dt>{{item.title}}</dt>
                        <dd>{{item.content}}</dd>
                    </dl>
                    <div class="beian">
                        <!-- <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">蜀ICP备13004223号-4</a> -->
                        <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">蜀ICP备13004223号-5</a>
                    </div>
                </div>
            </div>
            <div class="f-right">
                <img :src="accountUrl" alt="">
            </div>
        </diuv>
    </div>
</template>

<script>
    export default {
        name:'Footer',
        data() {
            return {
                info:[
                    {
                        title:'合作方式',
                        content:'4000-1573-11'
                    },
                    {
                        title:'地址:',
                        content:'四川省成都市高新区天府二街蜀都中心'
                    },
                    // {
                    //     title:'',
                    //     content:'业务邮箱:123123123@qq.com'
                    // }
                ],
                accountUrl:require('../../assets/images/account.jpg')
            }
        },
    }
</script>

<style lang="scss" scoped>
    .footer{
        width: 100%;
        height: 272px;
        background-color: #161616;
        .main-box{
            display: flex;
        }
        .f-left{
            .f-nav{
                margin-top: 56px;
                a{
                    margin-left: 78px;
                    color: #e0e0e0;
                }
            }
            .f-info{
                display: flex;
                margin-top: 100px;
                justify-content: space-around;
                .item{
                    margin-right: 100px;
                    text-align: left;
                    dt{
                        font-size: 17px;
                        color: #d6d6d6;
                    }
                    dd{
                        font-size: 20px;
                        color: #fff;
                    }
                }
            }
            .beian{
                a{
                    color: #d6d6d6;
                }
            }
        }
        .f-right{
            line-height: 272px;
            margin-left: 56px;
            img{
                width: 116px;
                height: 116px;
                vertical-align: middle;
            }
        }
    }
</style>